module.exports = __webpack_public_path__ + "img/add-remove-agenda.c9b8bd68.jpg";